export class OrderResult {
  accessionId: string;
  receivedOn: Date;
  collectedOn: Date;
  reportedOn: Date;
  mainAccountCode: string;
  mainAccountName: string;
  requsitionNumber: string;
  status: string;
  reportDtos: ReportDTO[];
  accountCodes: string[];
  totalCount: number;
  authorizedAccountCodes: string[];
  buCode: string;
  isPanelOrTest: string;
  testNames: string[];
  performedTestDto: any;
  isRead: boolean;
  reportDownloadConfig: string;
  authAccounts: AuthAccountDTO[];
  clientIdentifier1: string;
  clientIdentifier2: string;
  clientIdentifier3: string;
  clientIdentifier4: string;
  receivedOnTimeZone: string;
  collectedOnTimeZone: string;
  reportedOnTimeZone: string;
  donorName: string;
  patientFirstName: string;
  patientLastName: string;
  patientDOB: Date;
  patientGuid: string;
  physicianFirstName: string;
  physicianLastName: string;
  npiNumber?: number;
  results: any;
  isAbnormal?: boolean;
}
export class TestResultGraphResponse{
  patientFirstName: string;
  patientLastName: string;
  patientDOB: Date;
  gender: string;
  parameterCode:string;
  parameterName: string;
  resultUnit: string;
  mainAccountCode: string;
  collectionDate: Date;
  resultValue: string;
}

export class GraphResulData{
  results: ResultItem[];
  mainAccountCode: string;
  mainAccountName: string;
  patientFirstName: string;
  patientLastName: string;
  patientDOB: Date;
  testName:string;
  parameterName: string;
  resultUnit: string;
}

export class ResultItem {
  collectionDate: Date;
  resultValueWithUnit: string;
}

export class ReportDTO {
  reportGuid?: string;
  reportId: string;
  reportName: string;
  reportType: string;
  generatedOn: Date;
  isActive: boolean;
  reportLink: string;
  isRead: boolean;
  visitedBy: string;
  accessionId?: string;
  buCode: string;
  isAbnormal?: boolean;
}
export class OrderTestDto {
  testCode: string;
  testName: string;
  detail: string;
  testDetail: TestDetail;
  isPanelOrTest: string;
}

export class TestDetail {
  detail: string;
  resultUnit: string;
}

export class AuthAccountDTO {
  accountCode: string;
  accountName: string;
}

export class ClientId1SearchRequestDto {
  accountCodes: string[];
  clientIds: string[];
}

export class ClientId1SearchResponseDto {
  clientId: string;
  accessionId: string;
}

export class ResultDto {
  testName: string;
  parameterName: string;
  resultValue: string;
  resultUnit: string;
  abnormalTest: boolean;
}
